import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Questionnaires from '../../containers/Questionnaires/Questionnaires';

class QuestionnairesPage extends React.Component {
  render() {
    return <Questionnaires location={this.props.location} />;
  }
}

QuestionnairesPage.propTypes = {
  location: PropTypes.object,
};

const mapStateToProps = (_, ownProps) => ({
  location: ownProps.location,
});

export default connect(mapStateToProps)(QuestionnairesPage);